import { render, staticRenderFns } from "./OdontogramForm.vue?vue&type=template&id=5baf3abf&scoped=true"
import script from "./OdontogramForm.vue?vue&type=script&lang=js"
export * from "./OdontogramForm.vue?vue&type=script&lang=js"
import style0 from "./OdontogramForm.vue?vue&type=style&index=0&id=5baf3abf&prod&lang=scss&scoped=true"
import style1 from "./OdontogramForm.vue?vue&type=style&index=1&id=5baf3abf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baf3abf",
  null
  
)

export default component.exports